import toPairs from 'lodash/toPairs';

function toJS(value) {
  try {
    return value.toJS();
  } catch (error) {
    return error;
  }
}

export const dumpReduxState = (state) =>
  toPairs(state).reduce((acc, [key, value]) => {
    acc[key] = toJS(value);
    return acc;
  }, {});
